import { md5 } from './data';

import LocaleExtends from './extensions/LocaleExtends';

class UX1CurrencyPrivate extends LocaleExtends {
	private cachedCurrencySymbol: Common.IMap<string> = {};
	private cachedCurrencyFormat: Common.IMap<(val: number) => string> = {};

	private getHash(currencyCode: string, locale: string, options: Intl.NumberFormatOptions): string {
		let hashOptions = '';

		try {
			hashOptions = JSON.stringify(options);
		} catch (e) {}

		return md5(currencyCode + locale + hashOptions);
	}

	public getCurrencySymbol(currencyCode: string): string {
		if (!this.cachedCurrencySymbol[currencyCode]) {
			const formattedZero = Intl.NumberFormat('en', {
				style: 'currency',
				currency: currencyCode,
				maximumFractionDigits: 1
			}).format(0);

			this.cachedCurrencySymbol[currencyCode] = formattedZero.replace('0.0', '').trim();
		}

		return this.cachedCurrencySymbol[currencyCode];
	}

	public getCurrency(val: number, currencyCode: string, options: Intl.NumberFormatOptions = {}): string {
		const locale = this.getLocale().replace('_', '-');
		const hash = this.getHash(currencyCode, locale, options);

		if (!this.cachedCurrencyFormat[hash]) {
			this.cachedCurrencyFormat[hash] = Intl.NumberFormat(locale, {
				...options,
				style: 'currency',
				currency: currencyCode
			}).format;
		}

		return this.cachedCurrencyFormat[hash](val);
	}
}

export const ux1CurrencyPrivate = new UX1CurrencyPrivate();

class UX1Currency {
	/**
	 * Get current locale
	 */
	public getLocale(): string {
		return ux1CurrencyPrivate.getLocale();
	}

	/**
	 * Get currency symbol by currencyCode
	 */
	public getCurrencySymbol(currencyCode: string): string {
		return ux1CurrencyPrivate.getCurrencySymbol(currencyCode);
	}

	/**
	 * Get formatted string by value and currencyCode
	 */
	public getCurrency(val: number, currencyCode: string, options: Intl.NumberFormatOptions = {}): string {
		return ux1CurrencyPrivate.getCurrency(val, currencyCode, options);
	}
}

const ux1Currency = new UX1Currency();

export default ux1Currency;
